import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { PUTSystemCatalogCategory, PutSystemCatalogPayload } from '../queries'

type CategoryData = unknown // The return type of your mutation
type CategoryError = unknown // The error type
type CategoryVariables = unknown // The variables

// type
function usePutSystemCatalogCategory(
  options: Omit<
    UseMutationOptions<CategoryData, CategoryError, CategoryVariables>,
    'mutationFn'
  >
) {
  return useMutation({
    mutationFn: (payload: PutSystemCatalogPayload) =>
      PUTSystemCatalogCategory(payload),
    ...options,
  })
}

export default usePutSystemCatalogCategory
